import { createSvgIcon } from "@mui/material/utils";

export const ActiveCircle = createSvgIcon(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect
            x="0.652285"
            y="0.6225"
            width="18.675"
            height="18.675"
            rx="9.3375"
            fill="#ECFDFF"
        />
        <rect
            x="0.652285"
            y="0.6225"
            width="18.675"
            height="18.675"
            rx="9.3375"
            stroke="#06AED4"
            stroke-width="1.245"
        />
        <circle cx="9.98992" cy="9.95989" r="3.32" fill="#06AED4" />
    </svg>,
    "ActiveCircle"
);

